import { Card, CardContent } from "@/components/ui/card";
import { ScaleRating } from "@/components/doctor-training/scale-rating";

export const ScaleRatings = ({
  scaleRatings,
  bg = "bg-white",
}: {
  scaleRatings: DoctorTrainingReportSummaryScaleRating[];
  bg?: string;
}) => {
  return (
    <Card className={`${bg}`}>
      <CardContent className={"flex flex-col gap-4"}>
        {scaleRatings.map(({ value, title }) => (
          <ScaleRating key={title} value={value} title={title} />
        ))}
      </CardContent>
    </Card>
  );
};
